import React from "react";
import { Table, Button, Group, TextInput } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Plus, Trash } from "tabler-icons-react";
import { OptionsMetadata } from "@captiva/shared-types";

interface MetadataOptionsEditorProps {
  metadata: Record<string, OptionsMetadata>;
  onAdd: () => void;
  onRemove: (key: string) => void;
  onUpdate: (key: string, field: "key" | "label" | "value", value: string) => void;
  metaKey: string;
  setMetaKey: (val: string) => void;
  metaLabel: string;
  setMetaLabel: (val: string) => void;
  metaValue: string;
  setMetaValue: (val: string) => void;
  addDisabled: boolean;
}

export default function MetadataOptionsEditor({
  metadata,
  onAdd,
  onRemove,
  onUpdate,
  metaKey,
  setMetaKey,
  metaLabel,
  setMetaLabel,
  metaValue,
  setMetaValue,
  addDisabled
}: MetadataOptionsEditorProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const inputSize = isMobile ? "md" : "xs";

  const handleAdd = () => {
    onAdd();
  };
  return (
    <div style={{ background: '#f9f9f9', padding: isMobile ? 12 : 8, borderRadius: 8 }}>
      {Object.keys(metadata).length > 0 && (
        <Table striped highlightOnHover style={{ border: '1px solid #e0e0e0', borderRadius: 8, margin: "8px 0" }}>
          <thead>
            <tr><th>Meta Key</th><th>Label</th><th>Value</th><th> </th></tr>
          </thead>
          <tbody>
            {Object.entries(metadata).map(([key, meta]) => (
              <tr key={key}>
                <td>
                  <TextInput
                    size={inputSize}
                    value={key}
                    onChange={(e) => onUpdate(key, "key", e.target.value)}
                  />
                </td>
                <td>
                  <TextInput
                    size={inputSize}
                    value={meta.label || ""}
                    onChange={(e) => onUpdate(key, "label", e.target.value)}
                  />
                </td>
                <td>
                  <TextInput
                    size={inputSize}
                    value={String(meta.value ?? "")}
                    onChange={(e) => onUpdate(key, "value", e.target.value)}
                  />
                </td>
                <td>
                  <Button
                    size={inputSize}
                    color="red"
                    variant="outline"
                    onClick={() => onRemove(key)}
                    px={6}
                    style={{ minWidth: isMobile ? 44 : 0, minHeight: isMobile ? 44 : undefined }}
                    aria-label="Remove metadata"
                  >
                    <Trash size={isMobile ? 18 : 16} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      <Group mt="xs" spacing={isMobile ? 12 : 8} style={{ width: '100%', flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "flex-end" }}>
        <TextInput size={inputSize} style={{ flex: 1 }} label="Meta Key" value={metaKey} onChange={(e) => setMetaKey(e.target.value)} error={!metaKey && metaKey !== '' ? 'Required' : undefined} />
        <TextInput size={inputSize} style={{ flex: 1 }} label="Meta Label" value={metaLabel} onChange={(e) => setMetaLabel(e.target.value)} error={!metaLabel && metaLabel !== '' ? 'Required' : undefined} />
        <TextInput size={inputSize} style={{ flex: 1 }} label="Meta Value" value={metaValue} onChange={(e) => setMetaValue(e.target.value)} error={!metaValue && metaValue !== '' ? 'Required' : undefined} />
        <Button
          color="cap-blue"
          style={{ alignSelf: isMobile ? 'stretch' : 'flex-end', minWidth: 80, minHeight: isMobile ? 44 : undefined, marginTop: isMobile ? 8 : 0 }}
          variant="outline"
          size={inputSize}
          leftIcon={<Plus size={16} />}
          onClick={handleAdd}
          disabled={addDisabled}
        >
          Add
        </Button>
      </Group>
    </div>
  );
}
